import {
  ReactElement, useContext, useEffect,
} from 'react';
import { BrowserRouter as Router } from 'react-router-dom';
import { IntlProvider } from 'react-intl';
import theme from 'config/antdThemeConfig';
import { UserContext } from 'contexts';
import { ConfigProvider } from 'antd';
import RenderRoutes from 'routes/components/RenderRoutes';
import EmployerProvider from 'contexts/employerContext';
import JobsApplyProvider from 'contexts/jobsApplyContext';
import LookupsProvider from 'contexts/lookupsContext';
import SidebarProvider from 'contexts/sidebarContext';
import useAppVersionCheck from 'hooks/useAppVersionCheck';
import ErrorBoundary from './layouts/ErrorBoundary';
import Loader from './layouts/Suspense';
import GDPRPopup from './components/GDPRPopup';
import LOCALES from './constants/locales';
import { UserContextType } from './contexts/userContext';

const App = (): ReactElement => {
  const { locale, currentAppLocaleMessages } = useContext<UserContextType>(UserContext);
  const { isOldVersion, clearCache, error } = useAppVersionCheck();

  useEffect(() => {
    if (isOldVersion) {
      clearCache();
    }
  }, [isOldVersion]);

  if (error) {
    console.error(error);
  }

  return (
    <ConfigProvider theme={theme}>
      <JobsApplyProvider>
        <SidebarProvider>
          <EmployerProvider>
            <LookupsProvider>
              {currentAppLocaleMessages && (
                <IntlProvider
                  locale={locale}
                  defaultLocale={LOCALES.ENGLISH}
                  messages={currentAppLocaleMessages}
                >
                  <Loader>
                    <ErrorBoundary>
                      <Router>
                        <RenderRoutes />
                      </Router>
                      <GDPRPopup />
                    </ErrorBoundary>
                  </Loader>
                </IntlProvider>
              )}
            </LookupsProvider>
          </EmployerProvider>
        </SidebarProvider>
      </JobsApplyProvider>
    </ConfigProvider>
  );
};

export default App;
